import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { Stay } from '../../types';
import 'leaflet/dist/leaflet.css';
import { CiLocationOn } from 'react-icons/ci';
import { FaRegHeart, FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
const CustomMarker = ({ place }: { place: Stay }) => {
	const { i18n } = useTranslation()
	const iconHtml = `
    <div style="position: relative; width: 50px; height: 70px;">
      <div style="
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        border: 2px solid white;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        position: absolute;
        top: 0;
        left: 0;
      ">
        <img src="${place.images[0]?.url}" style="width: 100%; height: 100%; object-fit: cover;" />
      </div>
      <div style="
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        background: white;
        padding: 2px 6px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: bold;
        box-shadow: 0 1px 3px rgba(0,0,0,0.2);
        display: flex;
        align-items: center;
        gap: 4px;
      ">
        <span style="color: gold;">★</span> ${place.rate?.toFixed(1) ?? 'N/A'}
      </div>
    </div>
  `;

	const customIcon = L.divIcon({
		className: '',
		html: iconHtml,
		iconSize: [50, 70],
		iconAnchor: [25, 70],
	});

	return (
		<Marker position={[place?.latitude, place?.longitude]} icon={customIcon}>
			<Popup >
				<div className=" overflow-hidden text-sm  relative rounded-lg h-full flex flex-col " dir={i18n.language === "ar" ? "rtl" : "ltr"}>
					<div className="aspect-[4/3] w-full overflow-hidden rounded-lg">
						<img
							className="w-full h-full object-cover"
							src={place.images[0]?.url}
							alt="place"
							loading="lazy"
						/>
					</div>
					<div className="flex justify-between items-center">
						<h3 className="font-semibold text-lg text-nowrap">{place.title}</h3>
						<p className="flex items-center gap-1 text-secondry">
							<FaStar className="text-sm" />
							<span>{place.rate}</span>
						</p>
					</div>
					<p className="text-sm text-textSecond line-clamp-2">{place.details}</p>
					<div className="flex justify-between text-nowrap text-sm   border-t  border-textSecond border-dashed">
						<div className='flex flex-nowrap items-center'>
							<p className="font-semibold text-secondry text-nowrap">{place.price}</p>
							<span className="text-xs text-textSecond">/ Night</span>
						</div>
						<div className="flex items-center  justify-self-end  gap-1">
							<CiLocationOn className="text-lg text-secondry" />
							<p className='text-nowrap'>{place.location}</p>
						</div>
					</div>
					<div className="flex justify-between items-center mt-auto absolute w-full px-3 py-2 left-0">
						<p className="text-xs bg-primary text-white px-2 py-1 rounded">{place.type}</p>
						<button className="text-gray-500 hover:text-red-500 transition-colors">
							<FaRegHeart />
						</button>
					</div>
				</div>
			</Popup>
		</Marker>
	);
};

export default function MapView({ places }: { places: any }) {
	const normalizedPlaces = Array.isArray(places) ? places : [places];

	const validPlaces = normalizedPlaces.filter(
		(p) => typeof p?.latitude === "number" && typeof p?.longitude === "number"
	);

	if (validPlaces.length === 0) return <p>No valid places found</p>;


	const center: [number, number] = [
		validPlaces[0].latitude,
		validPlaces[0].longitude,
	];

	return (
		<MapContainer center={center} zoom={13} style={{ height: "100vh", width: "100%" }}>
			<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
			{validPlaces.map((place) => (
				<CustomMarker key={place?.id} place={place} />
			))}
		</MapContainer>
	);
}

